import React from 'react'
import Link from '@beatgig/design/components/link'
import { useMyAccount } from '@beatgig/auth-hooks'
import LinkToDashboard from '@beatgig/navigation/links/link-to-dashboard'
import { User } from '@beatgig/api'

type Props = Omit<React.ComponentProps<typeof Link>, 'onPress' | 'children'>

export default function SmartLinkToBookings(props: Props) {
  const { data } = useMyAccount()
  if (!User.hasOnboarded(data)) return null

  return (
    <LinkToDashboard>
      <Link block {...props}>
        Bookings
      </Link>
    </LinkToDashboard>
  )
}
